// Tercer sistema de storage/fetch aislado: ni "kofides_session" (Kofides
// contable) ni "sigte_session" (usuarios dentro de una empresa tenant).
// Este es el panel de plataforma (Cesar), un nivel arriba de las empresas.

export var SIGTE_PLATFORM_API = "/api/sigte-admin";
export var SIGTE_PLATFORM_SESSION_KEY = "sigte_platform_session";

export var spls = {
  get: function(k,fb){ try{ var v=localStorage.getItem(k); return v?JSON.parse(v):fb; }catch(e){return fb;} },
  set: function(k,v){ try{ localStorage.setItem(k,JSON.stringify(v)); }catch(e){} },
};

export function sigtePlatformApiFetch(path, opts) {
  opts = opts || {};
  var session = spls.get(SIGTE_PLATFORM_SESSION_KEY, null);
  var headers = Object.assign({}, opts.headers);
  if (!(opts.body instanceof FormData)) {
    headers["Content-Type"] = headers["Content-Type"] || "application/json";
  }
  if (session && session.token) {
    headers["Authorization"] = "Bearer " + session.token;
  }
  return fetch(SIGTE_PLATFORM_API + path, Object.assign({}, opts, { headers: headers }));
}

export async function sigtePlatformApiFetchChecked(path, opts) {
  var r = await sigtePlatformApiFetch(path, opts);
  var body = null;
  try {
    body = await r.json();
  } catch (e) {
    body = null;
  }
  if (!r.ok) {
    var msg = (body && body.error) ? body.error : "Error inesperado del servidor (" + r.status + ").";
    throw new Error(msg);
  }
  return body;
}
